import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux"
import type { AppDispatchT, AppStateT } from "../store/store"

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatchT>()
export const useAppSelector: TypedUseSelectorHook<AppStateT> = useSelector

/**
 * Typed `useStore`. Reads state on demand WITHOUT subscribing, so a hook that only needs
 * state inside its event handlers does not re-render its component on every action. Use
 * `useAppSelector` for anything that is actually rendered.
 */
export const useAppStore = () => useStore<AppStateT>()

export type BaseState<T> = {
    data: T
    status?: string
}
